export enum ImportPaths {
    Contracts = '/import/projects',
    Benefits = '/import/unique-benefits',
    BenefitTemplates = '/import/templated-benefits',
}
